import React,{Component} from 'react'
import {
    BrowserRouter as Router,
    // Switch,
    // Route,
    Link,
    // useParams
  } from "react-router-dom";
// import { Link } from "react-router-dom";
import contact_icon_1 from '../img/contact-icon-1.svg';
import contact_icon_2 from '../img/contact-icon-2.svg';
// import contact_icon_3 from '../img/contact-icon-3.svg';
import banner from '../img/student-services-banner.jpg';
import Client from "../contentful";

import qatarsvg from '../img/qatar.svg'
import logo from '../img/logo.svg'
import ussvg from '../img/us.svg'
import { Navbar,Nav,DropdownButton,NavDropdown , Dropdown , NavItem,NavLink, ButtonGroup ,Button} from 'react-bootstrap'

import * as contentful from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
export default class Transfers_to_suny extends Component {
 
   
    constructor(props){
        super(props);
        this.state = {
            // isLoaded:false,

            banner_image:"",
            array:[]




        }
        this.formatData = this.formatData.bind(this)
    }

    
    formatData(items) {
        this.setState({
            array:items
         })
         
         let tempItems = items.map(item => {
           let id = item.sys.id;

           let banner_image = item.fields.banner.fields.file.url

           this.setState({
            banner_image:banner_image
           })
              
         
      })
         return tempItems;   
      
    }
    
      componentDidMount() {
    
       

        Client.getEntries({
            content_type : "transfersToSunyUniversity"
          })
          .then(response=>{
            console.log(response.items)
            this.formatData(response.items)
            const description = response.items[0].fields?.description
            document.getElementById('rich-text-body').innerHTML = documentToHtmlString(description)

            const sunyAlbany147InNationalUniversities = response.items[0].fields?.sunyAlbany147InNationalUniversities
            document.getElementById('rich-text-body1').innerHTML = documentToHtmlString(sunyAlbany147InNationalUniversities)

            const sunyCantonCollegeOfTechnology = response.items[0].fields?.sunyCantonCollegeOfTechnology
            document.getElementById('rich-text-body2').innerHTML = documentToHtmlString(sunyCantonCollegeOfTechnology)

            const sunyCobleskillCollegeOfTechnology = response.items[0].fields?.sunyCobleskillCollegeOfTechnology
            document.getElementById('rich-text-body3').innerHTML = documentToHtmlString(sunyCobleskillCollegeOfTechnology)

            const sunyCortland = response.items[0].fields?.sunyCortland
            document.getElementById('rich-text-body4').innerHTML = documentToHtmlString(sunyCortland)

            const sunyDelhiCollegeOfTechnology = response.items[0].fields?.sunyDelhiCollegeOfTechnology
            document.getElementById('rich-text-body5').innerHTML = documentToHtmlString(sunyDelhiCollegeOfTechnology)

            const sunyEmpireStateCollege = response.items[0].fields?.sunyEmpireStateCollege
            document.getElementById('rich-text-body6').innerHTML = documentToHtmlString(sunyEmpireStateCollege)
            
            const sunyEnvironmentalScienceForestry = response.items[0].fields?.sunyEnvironmentalScienceForestry
            document.getElementById('rich-text-body7').innerHTML = documentToHtmlString(sunyEnvironmentalScienceForestry)

            const sunyFredonia = response.items[0].fields?.sunyFredonia
            document.getElementById('rich-text-body8').innerHTML = documentToHtmlString(sunyFredonia)

            const sunyPolytechnic = response.items[0].fields?.sunyPolytechnic
            document.getElementById('rich-text-body9').innerHTML = documentToHtmlString(sunyPolytechnic)

            const sunyMorrisville =  response.items[0].fields?.sunyMorrisville
            document.getElementById('rich-text-body10').innerHTML = documentToHtmlString(sunyMorrisville)

            const sunyNewPaltz = response.items[0].fields?.sunyNewPaltz
            document.getElementById('rich-text-body11').innerHTML = documentToHtmlString(sunyNewPaltz)

            const sunyOneonta = response.items[0].fields?.sunyOneonta
            document.getElementById('rich-text-body12').innerHTML = documentToHtmlString(sunyOneonta)

            const sunyOswego = response.items[0].fields?.sunyOswego
            document.getElementById('rich-text-body13').innerHTML = documentToHtmlString(sunyOswego)

            const sunyPlattsburgh = response.items[0].fields?.sunyPlattsburgh
            document.getElementById('rich-text-body14').innerHTML = documentToHtmlString(sunyPlattsburgh)

            const sunyPotsdam = response.items[0].fields?.sunyPotsdam
            document.getElementById('rich-text-body15').innerHTML = documentToHtmlString(sunyPotsdam)

            const sunyUpstateMedicalUniversity = response.items[0].fields?.sunyUpstateMedicalUniversity
            document.getElementById('rich-text-body16').innerHTML = documentToHtmlString(sunyUpstateMedicalUniversity)
            
          })
      }

        

    render() {
      function mouseenter0() {
        
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }

      function mouseleave0(){
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }
      function mouseenter1() {
        
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseleave1(){
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseenter2() {
        
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }

      function mouseleave2(){
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }
      function mouseenter3() {
        
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }

      function mouseleave3(){
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }
      function mouseenter4() {
        
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }

      function mouseleave4(){
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }
        return(
            <div>
           
           
           <Navbar bg="light" collapseOnSelect expand="lg" >
  <Navbar.Brand > <Link to="/" >
        <img className="logo horizontal-logo" src={logo} alt="logo"  style={{width:"150px",  marginLeft:"1rem",marginLeft:"5rem"}} />
      </Link></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="mr-auto">

      <Nav.Link >
        <Button variant="Info" style={{
          padding: "0px",
          marginTop: "0.4rem",
          marginRight: "1rem",
          marginLeft:"10px" }}>
            <Link to="/"  style={{color: "#424242"}}>
              <b> Home </b>
            </Link>
        </Button>
      </Nav.Link>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter0} onMouseLeave={mouseleave0}> 
        
       <Dropdown>
  <Dropdown.Toggle variant="bg-light" id="dropdown-basic0" >
  <Link to="/aboutus" style={{color: "#424242"}}>
             <b>About </b>
          </Link>
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item ><Link to="/presidentsbio" style={{color: "black"}}>President’s Bio</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/coreteam" style={{color: "black"}} >Core Team</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/organization_structure" style={{color: "black"}}> Organization Structure </Link></Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter1} onMouseLeave={mouseleave1}> 
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic1" >
        <Link to="/liveclassroomtechnology" style={{color: "#424242"}}>
            <b>Technology </b>
            
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/liveclassroomtechnology" style={{color: "black"}}>Live Classroom Technology</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/location" style={{color: "black"}}>Our Location</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/technology_partner" style={{color: "black"}}>Technology Partner</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter2} onMouseLeave={mouseleave2}>
         
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic2" >
        <Link to="/academics" style={{color: "#424242"}}>
           <b>Academics </b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/academics" style={{color: "black"}}>Degrees & Programs</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/admissions" style={{color: "black"}}>Admissions</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/transfers" style={{color: "black"}}>Transfers</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter3} onMouseLeave={mouseleave3}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic3" >
        <Link to="/aspirecampus" style={{color: "#424242"}}>
            <b>Aspire Campus</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/aspirezone" style={{color: "black"}}>Aspire Zone</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/aspireacademy" style={{color: "black"}}>Aspire Academy</Link></Dropdown.Item>
        {/* <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item> */}
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter4} onMouseLeave={mouseleave4}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic4" >
        <Link to="/partner_universities" style={{color: "#424242"}}>
           <b> Partner Universities</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/partner_university_suny" style={{color: "black"}}>SUNY Adirondack</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_south_carolina" style={{color: "black"}}>University of South Carolina</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_arkansas" style={{color: "black"}}> Arkansas State University</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <Nav.Link>
      <Button variant="Info" style={{
    padding: "0px",
    marginTop: "0.3rem",
    marginLeft:"10px"}}>
      <Link to="/contactus" style={{color: "#424242"}}>
        <b>Contact Us</b>
        </Link>
        </Button>
      </Nav.Link>


      <li class="nav-item dropdown">
        <Button variant="Info">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src={ussvg} />
          </a>
          </Button>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown3">
            <a class="dropdown-item" href=""><img src={qatarsvg}/></a>
          </div>
          
        </li>
     
    </Nav>
   
  </Navbar.Collapse>
</Navbar>  

           <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner carousel-slider">
    <div class="carousel-item active">	
      <img class="d-block w-100" src={this.state.banner_image} alt="First slide" />
      <div class="carousel-caption carousel-caption-centerr">
	    <h1> Transferring to a SUNY System University </h1>
	  </div>
    </div>
  </div>
</div>





<div class="container mb-5 mt-5">

 <p><div id="rich-text-body"></div></p>




</div>



<div class="container">
  <div class="row mb-5">
    <div class="col-lg-12">
     <p>These are available at the SUNY ADIRONDACK website and are listed below:</p> 
    </div> 

    <div class="col-lg-6">
      <div class="border-line p-25">
      <h5 class="font-w-600 mt-3 mb-4">SUNY Albany (#147 in National Universities)</h5>
      <ul class="list-unstyled line-height-30 height-100">
        <li><div id="rich-text-body1"></div> </li>
       
      </ul>
    </div>
    </div>


    <div class="col-lg-6">
      <div class="border-line p-25 height-100">
      <h5 class="font-w-600 mt-3 mb-4">SUNY Canton College of Technology (#23 in Regional Colleges North)</h5>
      <ul class="list-unstyled line-height-30">

        <li><span class="mr-2"><div id="rich-text-body2"></div></span></li>
        
      </ul>
    </div>
    </div>

  </div>



    <div class="row mb-5">

        <div class="col-lg-6">
          <div class="border-line p-25">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Cobleskill, College of Technology (#19 in Regional Colleges North)</h5>
          <ul class="list-unstyled line-height-30 height-100">
            <li><span class="mr-2"><div id="rich-text-body3"></div></span> </li>
          
          </ul>
        </div>
        </div>


        <div class="col-lg-6">
          <div class="border-line p-25 height-100">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Cortland (#63 in Regional Universities North)</h5>
          <ul class="list-unstyled line-height-30">

          <li><span class="mr-2"><div id="rich-text-body4"></div></span> </li>
          

          </ul>
        </div>
        </div>

    </div>




    <div class="row mb-5">
      
        <div class="col-lg-6">
          <div class="border-line p-25">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Delhi College of Technology (#15 in Regional Colleges North)</h5>
          <ul class="list-unstyled line-height-30 height-100">
          <li><span class="mr-2"><div id="rich-text-body5"></div></span>  </li>
          {/* <li><span class="mr-2"><i class="fas fa-angle-right"></i></span> Nursing RN to BSN </li>
          <li><span class="mr-2"><i class="fas fa-angle-right"></i></span> Business and Technology Management BBA </li>
          <li><span class="mr-2"><i class="fas fa-angle-right"></i></span> Criminal Justice BS </li>
          <li><span class="mr-2"><i class="fas fa-angle-right"></i></span> Culinary Arts Management BA </li>
          <li><span class="mr-2"><i class="fas fa-angle-right"></i></span> Event Management BBA </li>
          <li><span class="mr-2"><i class="fas fa-angle-right"></i></span> Hotel and Restaurant Management BBA </li> */}
          </ul>
        </div>
        </div>


        <div class="col-lg-6">
          <div class="border-line p-25 height-100">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Empire State College</h5>
          <ul class="list-unstyled line-height-30">

          <li><span class="mr-2"><div id="rich-text-body6"></div></span> </li>
          

          </ul>
        </div>
        </div>

    </div>

    <div class="row mb-5">
      
        <div class="col-lg-6">
          <div class="border-line p-25">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Environmental Science & Forestry (#121 in National Universities)</h5>
          <ul class="list-unstyled line-height-30 height-100">
          <li><span class="mr-2"><div id="rich-text-body7"></div></span>  </li>
          
          </ul>
        </div>
        </div>

        <div class="col-lg-6">
          <div class="border-line p-25 height-100">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Fredonia (#56 in Regional Universities North)</h5>
          <ul class="list-unstyled line-height-30">

          <li><span class="mr-2"><div id="rich-text-body8"></div></span></li>
    

          </ul>
        </div>
        </div>

    </div>



    <div class="row mb-5">
      
        <div class="col-lg-6">
          <div class="border-line p-25">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Polytechnic (#12 in Regional Universities North)</h5>
          <ul class="list-unstyled line-height-30 height-100">
          <li><span class="mr-2"><div id="rich-text-body9"></div></span>  </li>
          
          </ul>
        </div>
        </div>

        <div class="col-lg-6">
          <div class="border-line p-25 height-100">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Morrisville (#29 in Regional Colleges North)</h5>
          <ul class="list-unstyled line-height-30">

          <li><span class="mr-2"><div id="rich-text-body10"></div></span> </li>
          

          </ul>
        </div>
        </div>

    </div>



    <div class="row mb-5">
      
        <div class="col-lg-6">
          <div class="border-line p-25 height-100">
          <h5 class="font-w-600 mt-3 mb-4">SUNY New Paltz (#28 in Regional Universities North)</h5>
          <ul class="list-unstyled line-height-30 height-100">
          <li><span class="mr-2"><div id="rich-text-body11"></div></span>  </li>
         
          </ul>
        </div>
        </div>

        <div class="col-lg-6">
          <div class="border-line p-25 height-100">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Oneonta (#52 in Regional Universities North - tie)</h5>
          <ul class="list-unstyled line-height-30">
            <li><span class="mr-2"><div id="rich-text-body12"></div></span>  </li>
         
          </ul>
        </div>
        </div>

    </div>





    <div class="row mb-5">
      
        <div class="col-lg-6">
          <div class="border-line p-25 height-100">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Oswego (#52 in Regional Universities North - tie)</h5>
          <ul class="list-unstyled line-height-30 height-100">
            <li><span class="mr-2"><div id="rich-text-body13"></div></span>  </li>
            
          </ul>
        </div>
        </div>

        <div class="col-lg-6">
          <div class="border-line p-25 height-100">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Plattsburgh (#63 in Regional Universities North)</h5>
          <ul class="list-unstyled line-height-30">
          <li><span class="mr-2"><div id="rich-text-body14"></div></span> </li>
 
          </ul>
        </div>
        </div>

    </div>


    <div class="row mb-5">
      
        <div class="col-lg-6">
          <div class="border-line p-25 height-100">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Potsdam (#66 Regional Universities North)</h5>
          <ul class="list-unstyled line-height-30 height-100">
            <li><span class="mr-2"><div id="rich-text-body15"></div></span>  </li>
           
          </ul>
        </div>
        </div>

        <div class="col-lg-6">
          <div class="border-line p-25 height-100">
          <h5 class="font-w-600 mt-3 mb-4">SUNY Upstate Medical University</h5>
          <ul class="list-unstyled line-height-30">
            <li><span class="mr-2"><div id="rich-text-body16"></div></span>  </li>
            
          </ul>
        </div>
        </div>

    </div>





</div>


           



            </div>
            
        )
    }
}